import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import UploadPostLayer from "../../components/Post/UploadPostLayer";

const EditUploadPost = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb  id="title" title2="Upload Post" link2="/uploadpost" title="Edit Post" />

        {/* UsersListLayer */}
        <UploadPostLayer />

      </MasterLayout>

    </>
  );
};

export default EditUploadPost;
